<template>
  <v-dialog :value="isActive" @click:outside="closeDialog()" max-width="600" scrollable>
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ isEditMode ? "Actualizar" : "Crear" }} tarificador
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text :style="`max-height: ${DIALOG_MAX_HEIGHT}`">
            <v-row>
              <!-- Nombre -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider name="nombre" rules="required" v-slot="{ errors }">
                  <v-text-field
                    v-model="payload.name"
                    :error-messages="errors"
                    label="Nombre"
                    rounded
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Prefijo -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider name="prefijo" rules="required" v-slot="{ errors }">
                  <v-text-field
                    v-model="payload.prefix"
                    :error-messages="errors"
                    label="Prefijo"
                    rounded
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Longitud -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider name="longitud" rules="required|integer" v-slot="{ errors }">
                  <v-text-field
                    v-model="payload.longitud"
                    :error-messages="errors"
                    label="Longitud"
                    rounded
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Longitud -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider name="valor" rules="required|integer" v-slot="{ errors }">
                  <v-text-field
                    v-model="payload.value"
                    :error-messages="errors"
                    label="Valor"
                    rounded
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Tipo -->
              <v-col cols="12" class="py-0">
                <ValidationProvider name="tipo de factura" rules="required" v-slot="{ errors }">
                  <v-select
                    :disabled="isLoading"
                    v-model="payload.bill_type"
                    :items="['Minuto redondeado', 'Segundos']"
                    :error-messages="errors"
                    item-text="name"
                    item-value="id"
                    prepend-inner-icon="mdi-tag"
                    label="Tipo"
                    filled
                    rounded
                  ></v-select>
                </ValidationProvider>
              </v-col>

              <!-- Cliente -->
              <v-col cols="12" class="py-0">
                <ValidationProvider name="clientes" rules="" v-slot="{ errors }">
                  <v-select
                    :disabled="isLoading || isEditMode"
                    v-model="payload.client_id"
                    :items="clientList"
                    :error-messages="errors"
                    item-text="name"
                    item-value="id"
                    prepend-inner-icon="mdi-account"
                    label="Clientes"
                    filled
                    rounded
                  >
                    <!-- <template slot="selection" slot-scope="data">
                      {{ data.item.name + ", " + data.item.lastNAme }}
                    </template>
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item two-line selectable v-bind="attrs" v-on="on">
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ item.name + ", " + item.lastNAme }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ item.email }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template> -->
                  </v-select>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn @click="closeDialog()" class="px-8" color="error" rounded large text>
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn @click="handleSubmit(submitForm)" :disabled="isLoading" class="px-8" color="success" rounded large>
            {{ isEditMode ? "Actualizar" : "Crear" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import axios from "axios";
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
import { DIALOG_MAX_HEIGHT } from "@/utils";

export default {
  components: {
    vuescroll,
  },

  props: {
    isActive: {
      type: Boolean,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    dataToEdit: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {},
    },
  },

  data() {
    return {
      DIALOG_MAX_HEIGHT,
      isLoading: false,
      trunksTypeList: [],
      clientList: [],
      payload: {
        name: "",
        prefix: "",
        longitud: "",
        value: "",
        bill_type: "",
        client_id: null,
      },
    };
  },

  created() {
    this.getSelectsInfo();
    this.payload = { ...this.dataToEdit };
  },

  methods: {
    resetform() {
      this.payload.name = "";
      this.payload.prefix = "";
      this.payload.longitud = "";
      this.payload.value = "";
      this.payload.bill_type = "";
      this.payload.client_id = null;
    },

    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },

    async getSelectsInfo() {
      // this.isLoading = true;

      // const accessToken = localStorage.getItem("token");

      let endpoints = [`/clients/type_troncal_select`, `/clients/show`];

      await axios
        .all(
          endpoints.map((endpoint) =>
            PbxHttpClient.get(
              endpoint,
              // {
              //   headers: {
              //     Authorization: `Bearer ${accessToken}`,
              //   },
              // }
            ),
          ),
        )
        .then((res) => {
          this.trunksTypeList = res[0].data;
          this.clientList = res[1].data;
          // console.log("Listo", res);
        })
        .catch(() => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        });
      // .finally(() => {
      //   this.isLoading = false;
      // });
    },

    async submitForm() {
      this.isLoading = true;

      // const accessToken = localStorage.getItem("token");

      // const { id, ...payload } = this.payload;

      try {
        const { id, ...payload } = this.payload;
        const { data } = this.isEditMode
          ? await PbxHttpClient.put(`/clients/tarificador/${id}`, payload)
          : await PbxHttpClient.post("/clients/tarificador", payload);
        this.closeDialog(data.troncal);

        this.$snotify.success(`Troncal ${this.isEditMode ? "actualizado" : "creado"} con éxito.`, "¡Hecho!");
      } catch (err) {
        this.$snotify.error("No se pudo realizar la acción.", "¡Error!");
      }
    },
  },
};
</script>
